import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-17" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-18" data-mp="avd0itzoq0d6">
          <span aria-hidden="true" data-id="element-19" data-mp="fsv9ulhm6hlp">🎁 </span>5 Exclusive Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-20" data-mp="1tvhp3uw7kks">
          Valued at{' '}
          <span className="font-bold text-amber-600 line-through" data-id="element-21" data-mp="5vqmwjfy2i3u">
            $148 USD
          </span>{' '}
          — Included <span className="font-bold text-brand" data-id="element-22" data-mp="3o2eldqgho70j">FREE</span>
        </p>

        <ol className="mt-9 space-y-4" data-id="element-23" data-mp="3t0g76j5aukfp">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-[0_1px_3px_rgba(20,17,15,0.06)]" data-id="element-24" data-mp="3t2j3tm0yjbte" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-25" data-mp="1r8juh67eb4jc">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-14 w-11 shrink-0 rounded object-cover" data-id="element-26" data-mp="3df3axrdy5ll2" />
              <div data-id="element-27" data-mp="3n4wnaulwy4qd">
                <h3 className="font-display text-sm font-bold leading-snug text-ink" data-id="element-28" data-mp="3n6g20grx87q1">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] font-bold" data-id="element-29" data-mp="2zhezfa5rrqso">
                  <span className="text-amber-600 line-through" data-id="element-30" data-mp="2uhslszm148jc">
                    was {bonus.was}
                  </span>{' '}
                  <span className="text-brand" data-id="element-31" data-mp="38e5wnpw25bou">FREE</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}